import { APIMethod, fetchData } from "@client";

export async function moveProjectVersionComment(
  projectUuid,
  userUuid,
  versionKey,
  path,
  newPath
) {
  try {
    return await fetchData(
      "/v1/ws/project/comments/move",
      APIMethod.PUT,
      {
        mapRequestKeysToSnakeCase: false,
        data: {
          uuid: projectUuid,
          user: userUuid,
          version: versionKey,
          path,
          newPath
        },
      }
    );
  } catch(e) {
    console.error(e);
  }
}